import styled, { keyframes, css } from "styled-components"

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

export const MeshViewWrapper = styled.div<{
  $isFullScreen: boolean
  $fullscreenHeight?: number | string
  $background?: string
}>`
  flex-shrink: 0;
  position: relative;
  width: 100%;
  cursor: pointer;
  overflow: hidden;
  z-index: 10;
  touch-action: pan-y;

  transition: height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  height: ${({ $isFullScreen }) =>
    $isFullScreen
      ? "calc(100% - var(--mesh-padding-bottom, 24px) - var(--mesh-header-offset, 0px))"
      : "272px"};

  ${({ $isFullScreen }) =>
    $isFullScreen &&
    css`
      cursor: grab;
      touch-action: none;

      &:active {
        cursor: grabbing;
      }
    `}

  canvas {
    height: 100% !important;
  }
`

export const MeshContainer = styled.div<{ $isFullScreen?: boolean }>`
  width: 100%;
  height: 100%;
  pointer-events: ${({ $isFullScreen }) => ($isFullScreen ? "auto" : "none")};

  .comparison-bar {
    opacity: ${({ $isFullScreen }) => ($isFullScreen ? 1 : 0)};
    pointer-events: ${({ $isFullScreen }) => ($isFullScreen ? "auto" : "none")};
    transition: opacity 0.4s ease-out 0.2s;
  }

  .sbs-bg {
    display: none !important;
  }
`

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
`

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top-color: #4bd9de;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`

export const WeightInfoBox = styled.div`
  padding: 0 var(--app-horizontal-padding);
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  bottom: 0;
  pointer-events: none;
`

export const FullViewLabel = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(8px);
`

export const FullViewText = styled.span`
  font-size: 12px;
  line-height: 10px;
  color: rgba(255, 255, 255, 0.4);
`
